import React from 'react';
import { getLoginUrl } from '../utils/config';
import './CTA.css';

export const CTA: React.FC = () => {
  const handleComecarAgora = () => {
    window.location.href = getLoginUrl();
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">Pronto para começar?</h2>
        <p className="cta-description">
          Junte-se a times que estão transformando dados em decisões melhores.
        </p>
        <button className="cta-button" onClick={handleComecarAgora}>
          Começar Agora
        </button>
      </div>
    </section>
  );
};









